let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("321Ba")).then(() => parcelRequire('aq05I'));